import { suffixValueFormatter } from "utils/muiUtils";

export const columnesProducte = [
    {
        name: "codi",
        flex: 0.8,
    },
    {
        name: "nom",
        flex: 2,
    },
    {
        name: "zona",
        flex: 0.8,
    },
    {
        name: "tipus",
        flex: 0.8,
    },
    {
        name: "actiu",
        flex: 0.5,
    },
];
export const columnesRequisitRecurs = [
    {
        name: "nom",
        flex: 2,
    },
    {
        name: "producte",
        flex: 1.5,
    },
];
export const columnesZones = [
    {
        name: "codi",
        flex: 0.8,
    },
    {
        name: "nom",
        flex: 2,
    },
];
export const columnesUsuaris = [
    {
        name: "code",
        flex: 0.8,
    },
    {
        name: "givenName",
        flex: 2,
    },
    {
        name: "familyName",
        flex: 2,
    },
    {
        name: "email",
        flex: 2,
    },
];
export const columnesAgendaProducte = [
    {
        name: "data",
        flex: 1,
    },
    {
        name: "nom",
        flex: 2,
    },
    {
        name: "producte",
        flex: 2,
    },
    {
        name: "zona",
        flex: 2,
    },
    {
        name: "horaInici",
        flex: 1,
    },
    {
        name: "disponibilitat",
        flex: 1,
    },
];
export const columnesClients = [
    {
        name: "codi",
        flex: 0.8,
    },
    {
        name: "nom",
        flex: 2,
    },
    {
        name: "tipus",
        flex: 0.8,
    },
    {
        name: "preu",
        flex: 0.8,
        type: "currency",
        currencyDecimalPlaces: 2,
        formFieldProps: {
            suffix: " €",
        },
        valueFormatter: (params) => suffixValueFormatter(params),
    },
];
export const columnesCentreCost = [
    {
        name: "codi",
        flex: 0.8,
    },
    {
        name: "nom",
        flex: 2,
    },
    {
        name: "tipus",
        flex: 0.8,
    },
];
export const columnesPuntRuta = [
    {
        name: "zona",
        flex: 1,
    },
    {
        name: "hora",
        flex: 0.5,
    },
    {
        name: "total",
        flex: 0.5,
    },
    {
        name: "totalNous",
        flex: 0.5,
    },
    {
        name: "observacions",
        flex: 2,
    },
];
export const columnesRuta = [
    {
        name: "data",
        flex: 0.8,
    },
    {
        name: "recurs",
        flex: 1.5,
    },
    {
        name: "embarcacio",
        flex: 1.5,
    },
];
export const columnesSerie = [
    {
        name: "codi",
        flex: 1,
    },
    {
        name: "numeroActual",
        flex: 1,
    },
    {
        name: "activa",
        flex: 0.5,
    },
    {
        name: "descripcio",
        flex: 4,
    },
];
export const columnesArticle = [
    {
        name: "codi",
        flex: 0.5,
    },
    {
        name: "codiArticleEveret",
        flex: 0.5,
    },
    {
        name: "nom",
        flex: 1.5,
    },
    {
        name: "nomComercial",
        flex: 1.5,
    },
    {
        name: "articleCategoria",
        flex: 1,
    },
    {
        name: "iva",
        flex: 0.5,
        formFieldProps: {
            suffix: " %",
        },
        valueFormatter: suffixValueFormatter,
    },
    {
        name: "preu",
        flex: 0.75,
        formFieldProps: {
            suffix: " €",
        },
        valueFormatter: suffixValueFormatter,
    },
];
export const columnesOpcio = [
    {
        name: "nom",
        flex: 1.5,
    },
    {
        name: "article",
        flex: 1.5,
    },
];
export const columnesTripulant = [
    {
        name: "nom",
        flex: 1.75,
    },
    {
        name: "dataAlta",
        flex: 1,
    },
    {
        name: "dataBaixa",
        flex: 1,
    },
    {
        name: "actiu",
        flex: 1.5,
    },
    {
        name: "user",
        flex: 1.5,
    },
];
export const columnesOperacions = [
    {
        name: "data",
        flex: 0.75,
        minWidth: 175,
    },
    {
        name: "tipusOperacio",
        flex: 1,
        minWidth: 150,
    },
    {
        name: "numero",
        flex: 0.75,
        minWidth: 120,
    },
    {
        name: "ruta",
        flex: 1,
        minWidth: 250,
    },
    {
        name: "embarcacio",
        flex: 1,
        minWidth: 150,
    },
    {
        name: "user",
        flex: 1,
        minWidth: 150,
    },
    {
        name: "estatEveret",
        flex: 2,
        minWidth: 160,
    },
    {
        name: "importTotal",
        flex: 0.5,
        minWidth: 120,
        type: "currency",
        currencyDecimalPlaces: 2,
        formFieldProps: {
            suffix: " €",
        },
        valueFormatter: (params) => suffixValueFormatter(params),
    },
];
export const columnesTalonaris = [
    {
        name: "data",
        flex: 0.5,
    },
    {
        name: "primerNumero",
        flex: 0.75,
    },
    {
        name: "darrerNumero",
        flex: 0.75,
    },
    {
        name: "tipus",
        flex: 0.5,
    },
    {
        name: "afiliatCodi",
        flex: 1,
    },
    {
        name: "afiliatNom",
        flex: 1,
    },
    {
        name: "venedor",
        flex: 1,
    },
];
export const columnesReserves = [
    {
        name: "agendaProducte",
        flex: 3,
        minWidth: 220,
    },
    {
        name: "data",
        flex: 3,
        minWidth: 200,
    },
    {
        name: "numero",
        flex: 3,
        minWidth: 170,
    },
    {
        name: "primerRecurs",
        flex: 3,
        minWidth: 140,
    },
    {
        name: "importTotal",
        flex: 2.5,
        minWidth: 150,
        type: "currency",
        currencyDecimalPlaces: 2,
        formFieldProps: {
            suffix: " €",
        },
        valueFormatter: (params) => suffixValueFormatter(params),
    },
    {
        name: "user",
        flex: 3,
        minWidth: 150,
    },
    {
        name: "zona",
        flex: 3,
        minWidth: 150,
    },
    {
        name: "estat",
        flex: 2,
        minWidth: 130,
    },
];
export const columnesEmbarcacio = [
    {
        name: "codi",
        flex: 0.5,
    },
    {
        name: "nom",
        flex: 1.5,
    },
    {
        name: "capacitat",
        flex: 0.5,
    },
];
